import { forwardRef, useContext } from 'react'
import { faEuroSign } from '@fortawesome/free-solid-svg-icons'

import { StoreSettingsContext } from 'store/StoreSettingsContext'
import { FieldError } from 'react-hook-form'
import { WithClassName } from 'shared/types/general.types'
import type { Ref } from 'react'
import { InputGroup } from 'shared/molecules'

export type PriceInputProps = WithClassName<{
	id: string
	name: string
	label: string
	desc?: string
	placeholder?: string
	checked?: boolean
	ref?: Ref<HTMLInputElement>
	error?: FieldError | undefined
	type?: string
	step?: string
	disabled?: boolean
	required?: boolean
	onChange?: (e: any) => void
}>

export const PriceInput = forwardRef(
	(
		{ id, label, name, error, type, disabled, required, ...rest }: PriceInputProps,
		ref: Ref<HTMLInputElement>
	) => {
		const storeCtx = useContext(StoreSettingsContext)
		const currency = storeCtx?.storeSettings?.currency
		let currencyIcon: any = faEuroSign

		if (currency === 'ISK' || currency === 'DKK' || currency === 'SEK' || currency === 'NOK') {
			currencyIcon = 'kr.'
		}

		return (
			<InputGroup
				id={id}
				label={label}
				name={name}
				icon={currencyIcon}
				error={error}
				ref={ref}
				type={type}
				disabled={disabled}
				required={required}
				{...rest}
			/>
		)
	}
)
